import { useStaticQuery, graphql } from 'gatsby'

export const useOurServicesQuery = () => {
  const { wpPage, wp } = useStaticQuery(graphql`
    query OurServicesQuery {
      wpPage(title: { eq: "Home" }) {
        ourServices {
          ourServices {
            backgroundImageDesktop {
              sourceUrl
            }
            title
            subtitle
            services {
              icon {
                sourceUrl
              }
              label
              title
              text
              image {
                sourceUrl
                mediaDetails {
                  width
                  height
                }
              }
              altText
              link {
                title
                url
              }
              tabServices {
                icon {
                  sourceUrl
                }
                label
                content
                link {
                  title
                  url
                }
              }
            }
          }
        }
      }
      wp {
        acfOptionsCommonItems {
          commonItems {
            topButtonText
            phoneNumber
            topCallText
          }
        }
      }
    }
  `)
  return { wpPage, wp }
}
